import { ErrorCode, type ErrorCodeValue } from '../core/errorCodes';
import type { ErrorActionKind } from '../core/errorAction';

/** AUTO-GENERATED from `backend/app/errors/catalog.v1.json`. */
export type GeneratedCatalogEntry = {
  title: string;
  message: string;
  actions: ErrorActionKind[];
  httpStatus: number;
  surface: string;
};

export const generatedErrorCatalog: Partial<Record<ErrorCodeValue, GeneratedCatalogEntry>> = {
  [ErrorCode.INSUFFICIENT_WALLET_BALANCE]: {
    title: 'Insufficient balance',
    message: 'Please add funds to continue.',
    actions: ['wallet', 'dismiss'],
    httpStatus: 402,
    surface: 'global_modal',
  },
  [ErrorCode.AUTH_REQUIRED]: {
    title: 'Session invalid',
    message: 'Please sign in again to continue.',
    actions: ['sign_in', 'dismiss'],
    httpStatus: 401,
    surface: 'global_modal',
  },
  [ErrorCode.INVALID_CREDENTIALS]: {
    title: 'Couldn\'t sign in',
    message: 'Invalid email or password.',
    actions: ['dismiss'],
    httpStatus: 401,
    surface: 'alert',
  },
  [ErrorCode.TOKEN_INVALID]: {
    title: 'Session invalid',
    message: 'Please sign in again to continue.',
    actions: ['sign_in', 'dismiss'],
    httpStatus: 401,
    surface: 'global_modal',
  },
  [ErrorCode.TOKEN_MISSING]: {
    title: 'Session invalid',
    message: 'Please sign in again to continue.',
    actions: ['sign_in', 'dismiss'],
    httpStatus: 401,
    surface: 'global_modal',
  },
  [ErrorCode.INSUFFICIENT_SCOPE]: {
    title: 'Access denied',
    message: 'You don’t have access to this. Please sign in again or contact support.',
    actions: ['dismiss'],
    httpStatus: 403,
    surface: 'alert',
  },
  [ErrorCode.SUBSCRIPTION_REQUIRED]: {
    title: 'Subscription required',
    message: 'An active subscription is required to use this feature.',
    actions: ['subscription', 'dismiss'],
    httpStatus: 402,
    surface: 'alert',
  },
  [ErrorCode.NOT_AUTHORIZED]: {
    title: 'Access denied',
    message: 'You don’t have permission to do that.',
    actions: ['dismiss'],
    httpStatus: 403,
    surface: 'alert',
  },
  [ErrorCode.NOT_FOUND]: {
    title: 'Not found',
    message: 'We couldn’t find what you requested.',
    actions: ['dismiss'],
    httpStatus: 404,
    surface: 'alert',
  },
  [ErrorCode.VALIDATION_ERROR]: {
    title: 'Invalid input',
    message: 'Please check your inputs and try again.',
    actions: ['dismiss'],
    httpStatus: 400,
    surface: 'alert',
  },
  [ErrorCode.RATE_LIMITED]: {
    title: 'Slow down',
    message: 'Too many requests. Please try again shortly.',
    actions: ['dismiss'],
    httpStatus: 429,
    surface: 'alert',
  },
  [ErrorCode.SERVICE_UNAVAILABLE]: {
    title: 'Service unavailable',
    message: 'Service is temporarily unavailable. Please try again.',
    actions: ['retry', 'dismiss'],
    httpStatus: 503,
    surface: 'global_modal',
  },
  [ErrorCode.INTERNAL_ERROR]: {
    title: 'Something went wrong',
    message: 'Something went wrong. Please try again.',
    actions: ['dismiss'],
    httpStatus: 500,
    surface: 'alert',
  },
};

export function generatedEntry(code?: string | null): GeneratedCatalogEntry | undefined {
  if (!code) return undefined;
  return generatedErrorCatalog[code as ErrorCodeValue];
}
